import { render, staticRenderFns } from "./add-placeholders.vue?vue&type=template&id=68fb7980&scoped=true&"
import script from "./add-placeholders.vue?vue&type=script&lang=js&"
export * from "./add-placeholders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fb7980",
  null
  
)

export default component.exports